import classNames from "classnames";
import React from "react";
import { SimpleLink } from "../elements/SimpleLink";
import { lookupColourString } from "../lookups";
import { IVisual, Visual } from "../shared/Visual";

export const ComplexHero: React.FC<{
  id: string;
  title?: string | null;
  heading?: string | null;
  image?: IVisual;
  gradientColour?: Queries.GraphCMS_Colour | null;
  backgroundColour?: Queries.GraphCMS_Colour | null;
  linkTo?: string | null;
  linkTitle?: string | null;
  linkAsButton?: boolean | null;
}> = ({
  title,
  heading,
  image,
  gradientColour,
  backgroundColour,
  linkTo,
  linkTitle,
  linkAsButton,
}) => {
  return (
    <section
      data-component="Complex Hero"
      className={classNames(
        "grid h-[80vh] w-full auto-rows-min grid-cols-1 grid-rows-2 xl:h-[60vh]",
        lookupColourString(backgroundColour, "bg"),
        lookupColourString(gradientColour, "textForBg")
      )}
    >
      {gradientColour && (
        <svg
          className={classNames(
            "col-start-1 row-span-full row-start-1 h-full w-full fill-current",
            lookupColourString(gradientColour, "text")
          )}
          viewBox="0 0 1 1"
          preserveAspectRatio="none"
        >
          <polygon points="0,0 1,0 1,0.7 0,0.9" stroke="none" />
        </svg>
      )}

      <div
        className={classNames(
          "max-width relative col-start-1 row-span-full row-start-1 lg:col-start-1",
          "grid grid-cols-[2rem_1fr_2rem] lg:grid-cols-[8rem_1fr_2fr_8rem] lg:grid-rows-1 xl:grid-cols-[10rem_1fr_2fr_10rem]"
        )}
      >
        {(title ?? heading ?? linkTo ?? linkTitle) && (
          <div className="col-start-2 row-start-1 my-20px flex flex-col justify-center gap-y-20px lg:my-0">
            {title && <h1 className="h3">{title}</h1>}
            {heading && <h2 className="h4">{heading}</h2>}
            {linkTo && linkTitle && (
              <div className="flex">
                <SimpleLink
                  to={linkTo}
                  ariaLabel={linkTitle ? linkTitle : "Read more"}
                  className={linkAsButton ? "servicesButton" : undefined}
                >
                  <p className="read-more">{linkTitle}</p>
                </SimpleLink>
              </div>
            )}
          </div>
        )}

        {image && (
          <Visual
            className="col-start-2 row-start-2 lg:col-start-3 lg:row-start-1"
            visual={image}
            objectFit="contain"
          />
        )}
      </div>
    </section>
  );
  // <pre>
  //   {JSON.stringify(
  //     {
  //       id,
  //       title,
  //       heading,
  //       image,
  //       gradientColour,
  //       backgroundColour,
  //       linkTo,
  //       linkTitle,
  //       linkAsButton,
  //     },
  //     null,
  //     2
  //   )}
  // </pre>
};
